import { useEffect } from 'react';
import { hasAuthToken, shouldUseClientNav, redirectToFallback } from './index';

// Intercepts anchor clicks at the document level (capture phase, before React Router).
// Necessary because iebt-zing-storybook's NewMenu bundles its own Link components
// that cannot be patched via props — we must catch them at the DOM level.
export function useSmartNavInterceptor(): void {
  useEffect(() => {
    const handleCapture = (e: MouseEvent) => {
      // Pre-login (no JWT) → never bounce to legacy; let native anchor nav happen.
      if (!hasAuthToken()) return;
      const link = (e.target as Element).closest('a[href]') as HTMLAnchorElement | null;
      if (!link) return;
      const href = link.getAttribute('href');
      if (!href || href === '#' || href.startsWith('http') || href.startsWith('mailto:') || href.startsWith('//')) return;
      const normalizedPath = href.startsWith('/') ? href : '/' + href;
      if (!shouldUseClientNav(normalizedPath)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        redirectToFallback(normalizedPath);
      }
    };

    document.addEventListener('click', handleCapture, true);
    return () => document.removeEventListener('click', handleCapture, true);
  }, []);
}
